import Loader from "components/shared/loader";
import { paths } from "helpers/paths";
import { paramsObject } from "helpers/system";
import React, { useEffect } from "react";
import type { RouteComponentProps } from "react-router-dom";
import { connectKontur, type KonturIntegrationState } from "sources/profile/organization";

const connectionFailedIssue = "Произошла ошибка при подключении, попробуйте ещё раз";

export default function ConnectKontur(props: RouteComponentProps) {
    const { history, location } = props;

    useEffect(() => {
        const { code, state } = paramsObject(location.search);
        const redirectToIntegration = (konturIntegration?: KonturIntegrationState, konturIssue?: string) => {
            history.replace(paths.integrationItem("kontur"), { konturIntegration, konturIssue });
        };

        if (!code || !state) {
            redirectToIntegration(undefined, connectionFailedIssue);
            return;
        }

        connectKontur({ code, state })
            .then((response) => {
                const konturIntegration = response || undefined;
                redirectToIntegration(konturIntegration, konturIntegration ? undefined : connectionFailedIssue);
            })
            .catch(() => redirectToIntegration(undefined, connectionFailedIssue));
    }, [history, location.search]);

    return <Loader />;
}
